export const ALLOWED_USERNAMES = ['andrey', 'roman', 'lena', 'ann', 'nikolay', 'valentin', 'andreyk'];
//export const MAX_ITEMS = 50;


// WEBPACK FOOTER //
// ./src/components/constants.js